import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "pwdBox"
  }, [_c('p', {
    staticClass: "pwd-input-box"
  }, [_c('span', [_vm._v(i18n.tc("449"))]), _vm.inputType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pwd,
      expression: "pwd"
    }],
    attrs: {
      "id": "pwd",
      "value": "",
      "placeholder": i18n.tc("450"),
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwd) ? _vm._i(_vm.pwd, "") > -1 : _vm.pwd
    },
    on: {
      "focus": _vm.changeInputType,
      "change": function ($event) {
        var $$a = _vm.pwd,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwd = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.pwd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.pwd = $$c;
        }
      }
    }
  }) : _vm.inputType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pwd,
      expression: "pwd"
    }],
    attrs: {
      "id": "pwd",
      "value": "",
      "placeholder": i18n.tc("450"),
      "autocomplete": "off",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwd, "")
    },
    on: {
      "focus": _vm.changeInputType,
      "change": function ($event) {
        _vm.pwd = "";
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pwd,
      expression: "pwd"
    }],
    attrs: {
      "id": "pwd",
      "value": "",
      "placeholder": i18n.tc("450"),
      "autocomplete": "off",
      "type": _vm.inputType
    },
    domProps: {
      "value": _vm.pwd
    },
    on: {
      "focus": _vm.changeInputType,
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.pwd = $event.target.value;
      }
    }
  })]), _c('p', {
    staticClass: "pwd-input-box"
  }, [_c('span', [_vm._v(i18n.tc("451"))]), _vm.inputType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newPwd,
      expression: "newPwd"
    }],
    attrs: {
      "id": "newPwd",
      "value": "",
      "placeholder": i18n.tc("452"),
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPwd) ? _vm._i(_vm.newPwd, "") > -1 : _vm.newPwd
    },
    on: {
      "focus": _vm.changeInputType,
      "change": function ($event) {
        var $$a = _vm.newPwd,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPwd = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.newPwd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.newPwd = $$c;
        }
      }
    }
  }) : _vm.inputType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newPwd,
      expression: "newPwd"
    }],
    attrs: {
      "id": "newPwd",
      "value": "",
      "placeholder": i18n.tc("452"),
      "autocomplete": "off",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPwd, "")
    },
    on: {
      "focus": _vm.changeInputType,
      "change": function ($event) {
        _vm.newPwd = "";
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newPwd,
      expression: "newPwd"
    }],
    attrs: {
      "id": "newPwd",
      "value": "",
      "placeholder": i18n.tc("452"),
      "autocomplete": "off",
      "type": _vm.inputType
    },
    domProps: {
      "value": _vm.newPwd
    },
    on: {
      "focus": _vm.changeInputType,
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.newPwd = $event.target.value;
      }
    }
  })]), _c('p', {
    staticClass: "pwd-input-box"
  }, [_c('span', [_vm._v(i18n.tc("453"))]), _vm.inputType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pwdAgain,
      expression: "pwdAgain"
    }],
    attrs: {
      "id": "pwdAgain",
      "value": "",
      "placeholder": i18n.tc("452"),
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwdAgain) ? _vm._i(_vm.pwdAgain, "") > -1 : _vm.pwdAgain
    },
    on: {
      "focus": _vm.changeInputType,
      "change": function ($event) {
        var $$a = _vm.pwdAgain,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwdAgain = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.pwdAgain = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.pwdAgain = $$c;
        }
      }
    }
  }) : _vm.inputType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pwdAgain,
      expression: "pwdAgain"
    }],
    attrs: {
      "id": "pwdAgain",
      "value": "",
      "placeholder": i18n.tc("452"),
      "autocomplete": "off",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwdAgain, "")
    },
    on: {
      "focus": _vm.changeInputType,
      "change": function ($event) {
        _vm.pwdAgain = "";
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pwdAgain,
      expression: "pwdAgain"
    }],
    attrs: {
      "id": "pwdAgain",
      "value": "",
      "placeholder": i18n.tc("452"),
      "autocomplete": "off",
      "type": _vm.inputType
    },
    domProps: {
      "value": _vm.pwdAgain
    },
    on: {
      "focus": _vm.changeInputType,
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.pwdAgain = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "cursor-button",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._m(0)])]);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('p', [_c('a', [_vm._v(i18n.tc("12"))])]);
}];
export { render, staticRenderFns };